export default __webpack_public_path__ + "static/media/profile-updated.e2c55de5.svg";